export default __webpack_public_path__ + "static/media/c-googlemaps.fc63bcd1.svg";